export class AppError<T extends object>  {
  data: T;
  status: number;
  code: string;
  message: string;
  errors: string[];
  response : any;

  constructor(response : any ,data: T, code: string, status: number, message: string, errors: string[]) {
    this.data = data;
    this.response = response;
    this.code = code;
    this.status = status;
    this.message = message;
    const myerrors:string[] =[];
    if (errors && errors.length > 0 ) {
      errors.forEach((myerror: any) => {
        myerrors.push(myerror.userMessageGlobalisationCode);
      });
    }
    this.errors = myerrors;
  }

  isErrorStatus() : boolean {
    return this.status === 400;
  }

  isForbidden() : boolean {
    return this.status === 403;
  }

  isDomainRuleValidationError() : boolean {
    return this.code === "message";
  }
}